import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { LOGO_URL } from "../lib/utils";
import { Lock } from "lucide-react";

function formatError(detail) {
  if (detail == null) return "Une erreur est survenue. Réessayez.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

const AdminLogin = () => {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(formatError(err?.response?.data?.detail) || err.message);
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login" className="min-h-screen bg-forest flex items-center justify-center px-6">
      <div className="w-full max-w-md bg-white p-10 shadow-2xl">
        <div className="flex items-center gap-3 mb-8">
          <img src={LOGO_URL} alt="FLOW" className="h-11 w-auto object-contain" />
          <div>
            <p className="font-heading uppercase tracking-widest text-xs font-bold text-burnt">Espace admin</p>
            <h1 className="hd-italic text-2xl text-forest leading-none">FLOW</h1>
          </div>
        </div>

        <form onSubmit={onSubmit} className="space-y-5">
          <div>
            <label className="block text-sm font-semibold text-forest mb-2">Courriel</label>
            <input
              data-testid="admin-login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="input-line"
            />
          </div>
          <div>
            <label className="block text-sm font-semibold text-forest mb-2">Mot de passe</label>
            <input
              data-testid="admin-login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="input-line"
            />
          </div>
          {error && (
            <p data-testid="admin-login-error" className="text-sm text-red-600 bg-red-50 border border-red-200 px-3 py-2">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="btn-primary w-full justify-center disabled:opacity-60"
          >
            <Lock size={16} /> {loading ? "Connexion..." : "Se connecter"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
